<template>
  <v-container>
    <v-row>
      <v-col cols="8" sm="6">
        <v-autocomplete
          variant="underlined"
          v-model="selectedGroup"
          :items="groups"
          item-title="name"
          item-value="id"
          label="Выберите группу"
        />
      </v-col>
      <v-col cols="8" sm="6">
        <v-select
          variant="underlined"
          :items="semesters"
          v-model="semester"
          label="Выберите семестр"
          @update:model-value="loadSemesterSettings"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8" sm="6">
        <datepicker
          :max="semesterSettings ? semesterSettings.end : null"
          :min="semesterSettings ? semesterSettings.begin : null"
          v-model="dateStart"
          placeholder="Начало периода"
        ></datepicker>
      </v-col>
      <v-col cols="8" sm="6">
        <datepicker
          :max="semesterSettings ? semesterSettings.end : null"
          :min="semesterSettings ? semesterSettings.begin : null"
          v-model="dateEnd"
          placeholder="Конец периода"
        ></datepicker>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="8" class="d-flex align-center justify-left">
        <v-btn color="primary" variant="tonal" @click="getAttendGroup">
          Применить
        </v-btn>
        <v-btn
          variant="text"
          icon="mdi-microsoft-excel"
          color="green darken-2"
          @click="printExcel"
        ></v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-chip style="margin: 4px" class="font-weight-bold" color="primary">
          Итог: {{ total_all }}
        </v-chip>
        <v-chip  style="margin: 4px" class="font-weight-bold" color="green"> по УП: {{ total_good_all }} </v-chip>
        <v-chip   style="margin: 4px" class="font-weight-bold" color="red"> по НП: {{ total_no_good_all }} </v-chip>
        
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="fields"
      class="my-table"
      hide-default-footer
      :items-per-page="fields.length"
      height="500"
      fixed-header
    />
    <v-overlay
      v-model="processData"
      persistent
      class="align-center justify-center"
    >
      <v-progress-circular
        color="primary"
        size="64"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
<script>
import datepicker from "moodleDir/procollege/lib/vue/datepicker.vue";
export default {
  data() {
    return {
      groups: [],
      selectedGroup: null,
      semesters: [1, 2],
      semester: null,
      dateEnd: "",
      dateStart: "",
      semesterSettings: null,
      headers: [],
      fields: [],
      processData: false,
      total_all: 0,
      total_good_all: 0,
      total_no_good_all: 0,
    };
  },
  components: {
    datepicker,
  },
  created() {
    this.getGroups();
    this.loadSemesterSettings();
  },
  methods: {
    getGroups() {
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/secretariat/attendanceReport/getGroups"
        )
        .then((response) => {
          this.groups = response.data;
          if (this.groups.length == 1) {
            this.selectedGroup = response.data[0].id;
          }
        });
    },

    getAttendGroup() {
      this.processData = true;
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/reportsLocal/attendanceStudentsReport/getAttendGroup",
          new URLSearchParams({
            group_id: this.selectedGroup,
            dateEnd: this.dateEnd,
            dateStart: this.dateStart,
            semester: this.semester,
          })
        )
        .then((response) => {
          this.headers = [
            { title: "№", value: "num", align: "start" },
            { title: "ФИО студента", value: "fio" },
            { title: "Всего", value: "all" },
            { title: "Всего по УП", value: "good_all" },
            { title: "Всего по НП", value: "no_good_all" },
            { title: "УП", value: "good_reason" },
            { title: "Б", value: "sick" },
            { title: "НП", value: "no_good_reason" },
            { title: "ОТ", value: "absent" },
            { title: "ОП", value: "late" },
            { title: "ОСВ", value: "released" },
          ];

          this.fields = [];
          for (let i in response.data.dates) {
            this.headers.push({
              title: response.data.dates[i],
              value: "date" + i,
            });
          }

          this.total_all = response.data.total["total_all"];
          this.total_good_all = response.data.total["total_good_all"];
          this.total_no_good_all = response.data.total["total_no_good_all"];

          let k = 1;
          for (let i in response.data.students) {
            this.fields.push({
              num: k++,
              fio: response.data.students[i].name,
              all: response.data.students[i].attendance["all"],
              good_all: response.data.students[i].attendance["good_all"],
              no_good_all: response.data.students[i].attendance["no_good_all"],
            });
            let current = this.fields.length - 1;
            if (response.data.students[i].attendance["cause"] !== undefined) {
              this.fields[current]["sick"] =
                response.data.students[i].attendance["cause"]["Б"] !== undefined
                  ? response.data.students[i].attendance["cause"]["Б"]
                  : "";
              this.fields[current]["good_reason"] =
                response.data.students[i].attendance["cause"]["УП"] !==
                undefined
                  ? response.data.students[i].attendance["cause"]["УП"]
                  : "";
              this.fields[current]["no_good_reason"] =
                response.data.students[i].attendance["cause"]["НП"] !==
                undefined
                  ? response.data.students[i].attendance["cause"]["НП"]
                  : "";
              this.fields[current]["absent"] =
                response.data.students[i].attendance["cause"]["ОТ"] !==
                undefined
                  ? response.data.students[i].attendance["cause"]["ОТ"]
                  : "";
              this.fields[current]["late"] =
                response.data.students[i].attendance["cause"]["ОП"] !==
                undefined
                  ? response.data.students[i].attendance["cause"]["ОП"]
                  : "";
              this.fields[current]["released"] =
                response.data.students[i].attendance["cause"]["ОСВ"] !==
                undefined
                  ? response.data.students[i].attendance["cause"]["ОСВ"]
                  : "";
            }

            for (let t in response.data.dates) {
              this.fields[current]["date" + t] =
                response.data.students[i].attendance[t];
            }
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.processData = false;
        });
    },

    loadSemesterSettings() {
      this.processData = true;
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/core_procollege/helpers/TimetableHelper/timetableGetSemesterDates",
          new URLSearchParams({
            semester: this.semester,
          })
        )
        .then((response) => {
          this.semesterSettings = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.processData = false;
        });
    },

    printExcel() {
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/reportsLocal/attendanceStudentsReport/printExcelReport",
          new URLSearchParams({
            group_id: this.selectedGroup,
            dateEnd: this.dateEnd,
            dateStart: this.dateStart,
            semester: this.semester,
          }),
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          let link = document.createElement("a");
          link.href = URL.createObjectURL(response.data);

          let filename = "attendanceReport.xlsx";

          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style>
/* Обёртка таблицы */
.my-table .v-table__wrapper {
  overflow-y: auto !important;
}

.my-table td:nth-child(2) {
  position: sticky;
  left: 0;
  background: white;
}

/* Стили ячеек */
.my-table td,
.my-table th {
  padding: 6px 10px;
  white-space: nowrap;
  min-width: 82px;
}

.my-table td {
  border: 1px solid rgb(187, 177, 177);
}

.my-table tbody tr:hover {
  background: rgb(236, 234, 234);
}
</style>


